import React, { useMemo, useState } from 'react';
import { ModalDispatchContext, ModalsStateContext } from '@store/modalContext';

const ModalsProvider: React.FC<ModalsProviderProps> = ({ children }) => {
  const [openedModals, setOpenedModals] = useState<Modal[]>([]);

  const open = (Component: () => React.ReactElement, props: object) => {
    setOpenedModals((modals) => [...modals, { Component, props }]);
  };

  const close = (Component: () => React.ReactElement) => {
    setOpenedModals((modals) => modals.filter((modal) => modal.Component !== Component));
  };

  const reset = () => {
    setOpenedModals([]);
  };

  const dispatch = useMemo(() => ({ open, close, reset }), []);

  return (
    <ModalsStateContext.Provider value={openedModals}>
      <ModalDispatchContext.Provider value={dispatch}>{children}</ModalDispatchContext.Provider>
    </ModalsStateContext.Provider>
  );
};

export default ModalsProvider;
